import LocationAutocomplete from '../LocationAutocomplete';
import { t } from '../../utils/i18n';

export default function HeroSearch({
  searchMode,
  onSearchModeChange,
  searchQuery,
  onSearchQueryChange,
  onLocationSelect,
  onSearch,
  locationAutocompleteRef,
}) {
  return (
    <div className="landing-search-panel w-full">
      <form onSubmit={onSearch}>
        <div className="flex border-b border-[var(--color-border)]">
          <button
            type="button"
            onClick={() => onSearchModeChange('parent')}
            className={`landing-search-tab flex-1 px-4 py-3 text-sm font-medium transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-500/40 ${
              searchMode === 'parent' ? 'landing-search-tab--active' : ''
            }`}
          >
            {t('landing.search.findSitter')}
          </button>
          <button
            type="button"
            onClick={() => onSearchModeChange('sitter')}
            className={`landing-search-tab flex-1 px-4 py-3 text-sm font-medium transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-500/40 ${
              searchMode === 'sitter' ? 'landing-search-tab--active' : ''
            }`}
          >
            {t('landing.search.findJob')}
          </button>
        </div>

        <div className="p-4 sm:p-5 space-y-3">
          <div className="landing-search-field relative">
            <LocationAutocomplete
              ref={locationAutocompleteRef}
              value={searchQuery}
              onChange={onSearchQueryChange}
              onSelect={onLocationSelect}
              placeholder={t('landing.search.placeholder')}
              className="w-full"
              variant="landing"
              debounceMs={300}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  locationAutocompleteRef.current?.closeDropdown();
                  onSearch(e);
                }
              }}
            />
          </div>

          <button
            type="submit"
            onClick={() => locationAutocompleteRef.current?.closeDropdown()}
            className="landing-search-cta w-full py-3 text-[15px] font-semibold rounded-xl transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/50 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-[var(--color-bg)]"
          >
            {searchMode === 'parent'
              ? t('landing.search.submitSitter')
              : t('landing.search.submitJob')}
          </button>
        </div>
      </form>
    </div>
  );
}
